module.exports = __webpack_public_path__ + "img/pc_water.7df74704.png";